import { config } from '@mp/config';
import { useCurrentUser, useProfileStats } from '@mp/hooks';

export const useAttendanceTab = () => {
  const { isAgency } = useCurrentUser();

  const { no_shows_count, late_cancellations_count, jobs_completed_count, status } =
    useProfileStats();

  const showPerfectAttendance =
    late_cancellations_count === 0 &&
    no_shows_count === 0 &&
    status === 'active' &&
    jobs_completed_count >= 5;

  const showDeactivated = status === 'deactivated';

  const link = isAgency
    ? config.help.cancellationsAndNoShowAgency
    : config.help.cancellationsAndNoShow;

  const hasCardsToShow = showDeactivated || showPerfectAttendance;

  return {
    showPerfectAttendance,
    showDeactivated,
    link,
    noShowsCount: no_shows_count,
    lateCancellationsCount: late_cancellations_count,
    hasCardsToShow,
  };
};
